<template>
  <v-dialog :model-value="openShareDialog" @update:model-value="handleToogleDialog" width="440" @keydown.stop.esc="$emit('close')">
    <div class="dialog">
      <div class="d-flex mb-6 align-center">
        <v-icon size="large" class="mr-3" style="margin-top: 2px;">mds:group_add</v-icon>
        <span class="text-title mr-3 text-truncate">Share '{{ workflow.name }}'</span>
        <v-spacer/>
        <help-dialog-share-workflow #default="{ props }">
          <v-btn
            variant="text"
            size="small"
            icon="mdi-help-circle-outline"
            v-bind="props"
            class="mr-2"
            :disabled="$store.state.isWorkflowDisabled"
          />
        </help-dialog-share-workflow>
        <v-btn size="x-small" variant="text" color="grey" @click="$emit('close')" icon="mdi-close">
        </v-btn>
      </div>

      <invite-team-members-field v-model="invites" ref="membersField"/>
      <div class="text-subtitle mt-6">
        Members in '{{ project.name }}' with access:
      </div>
      <base-team-member v-for="member in listTeamMembers" :teamMember="member" :project="project" :key="member.id"/>

      <div class="mt-6">
        <span class="text-subtitle">
          Public access:
        </span>
        <v-select
          :disabled="!isShareEnabled || $store.state.isWorkflowDisabled"
          v-model="accessLevel"
          :items="accessLevelItems"
          item-title="name"
          item-value="value"
          variant="outlined"
          width="100%"
          hide-details
          class="mx-0 mb-0"
          :class="isShareEnabled ? 'access-level-select' : 'access-level-select access-disabled'"
        >
        </v-select>
      </div>

      <div class="d-flex justify-space-between mt-6">
        <v-btn variant="tonal" size="large" @click="saveLinkToClipboard">
          <v-icon size="large" class="mr-1">mds:link</v-icon>Copy link
        </v-btn>
        <v-btn variant="flat" size="large" @click="saveAndClose">
          {{ invites?.length > 0 ? 'Invite ' + invites.length + ' new members' : 'Close' }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import HelpDialogShareWorkflow from '@/components/HelpDialogShareWorkflow.vue'
import InviteTeamMembersField from '@/components/InviteTeamMembersField.vue'
import BaseTeamMember from '@/components/BaseTeamMember.vue'
import workflowApi from '@/api/workflowApi'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'workflow-share-dialog',
  components: { HelpDialogShareWorkflow, BaseTeamMember, InviteTeamMembersField },
  props: {
    isShareEnabled: {},
    openShareDialog: {},
    workflow: {}
  },
  data () {
    return {
      invites: [],
      accessLevelItems: [{
        name: 'No access',
        value: 'PRIVATE'
      }, {
        name: 'Anyone with link can view',
        value: 'READ'
      }]
    }
  },
  computed: {
    ...mapState({
      listTeamMembers: state => state.teamMembers.teamMembers
    }),
    ...mapGetters({
      project: 'projectMemberships/activeProject'
    }),
    numInvites () {
      return this.$refs.membersField?.addMembersLength || 0
    },
    accessLevel: {
      get: function () {
        return this.workflow.accessLevel || this.accessLevelItems[0]
      },
      set: function (value) {
        workflowApi.updateWorkflowNoHistoryMutation(
          this.$route.params.projectId,
          {
            id: this.$route.params.id,
            expectedVersion: this.workflow.version,
            accessLevel: value
          }
        )
      }
    },
    windowLocation: {
      get: function () { return window.location }
    }
  },
  methods: {
    saveAndClose () {
      this.$refs.membersField.inviteTeamMembers()
      this.$emit('close')
    },
    saveLinkToClipboard () {
      navigator.clipboard.writeText(this.windowLocation)
      this.$store.commit('snackbar/showMessage', { content: 'Link copied. You can share it with your team!', timeout: 3000 }, { root: true })
    },
    handleToogleDialog (val) {
      if (!val) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.dialog {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #FCFCFC;
  background: #FCFCFC;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
}

.access-level-select {
  border: none; /* Remove default border */
  outline: none; /* Remove outline when clicked */
  appearance: none; /* Remove default styling on some browsers */
  margin: 5px;

  max-width: 100%;
  :focus {
    outline:none;
  }
}

.access-level-select option {
  border: none; /* Remove border on option elements */
  padding: 5px; /* Add some padding for visual separation */
  font-size: 16px; /* Set a font size */
  color: #333; /* Set font color */
  appearance: none;
}

.access-disabled .v-select__selection  {
  color: grey !important;
}
</style>
